module.exports = __webpack_public_path__ + "img/SWP_Axe_1H_05 (1).f1c12be4.png";